"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  className: _propTypes["default"].string,
  content: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].bool]),
  error: _propTypes["default"].bool,
  type: _propTypes["default"].string.isRequired
};
var defaultProps = {
  error: false
};

var HelperText = function HelperText(_ref) {
  var _classNames;

  var error = _ref.error,
      content = _ref.content,
      type = _ref.type,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["error", "content", "type", "className"]);

  var baseClass = "grv-form-field__helper";
  var typeClass = baseClass + "--" + type;
  var errorClass = baseClass + "--error";
  var classes = (0, _classnames["default"])(className, baseClass, typeClass, (_classNames = {}, _classNames[errorClass] = error, _classNames));

  if (content) {
    return /*#__PURE__*/_react["default"].createElement("span", _extends({}, otherProps, {
      className: classes
    }), content);
  }

  return null;
};

HelperText.propTypes = propTypes;
HelperText.defaultProps = defaultProps;
var _default = HelperText;
exports["default"] = _default;